module.exports = __webpack_public_path__ + "img/04.a0e6643f.jpg";